<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6m0 2h7v5h5v11H6V4m2 8v2h8v-2H8m0 4v2h5v-2H8z"/>
    </svg>
</template>

<script>
export default {
    name: 'FileDocumentOutlineIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
